import React from 'react';

export const NoCooling = () => (
  <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5022 27.8375L27.1088 1.44999" stroke="#FD9800" strokeWidth="2" />
    <path d="M1.5022 1.6438L27.5022 27.6438" stroke="#FD9800" strokeWidth="2" />
  </svg>
);
